import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock, withCtx as _withCtx, toDisplayString as _toDisplayString, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode } from "vue";
var _hoisted_1 = {
  "class": ""
};
var _hoisted_2 = /*#__PURE__*/_createElementVNode("h1", {
  "class": "mb-8 text-3xl font-bold"
}, "Lead Transfer", -1);
var _hoisted_3 = {
  "class": "bg-white border rounded-md shadow p-4"
};
var _hoisted_4 = {
  "class": "mb-6 w-full flex justify-start"
};
var _hoisted_5 = {
  "class": "w-1/5"
};
var _hoisted_6 = /*#__PURE__*/_createElementVNode("label", {
  "class": "block text-gray-700 font-bold"
}, "Start Date", -1);
var _hoisted_7 = {
  "class": "w-1/5"
};
var _hoisted_8 = /*#__PURE__*/_createElementVNode("label", {
  "class": "block text-gray-700 font-bold"
}, "End Date", -1);
var _hoisted_9 = {
  "class": "w-1/5"
};
var _hoisted_10 = /*#__PURE__*/_createElementVNode("label", {
  "class": "block text-gray-700 font-bold"
}, "Tenant", -1);
var _hoisted_11 = {
  "class": "w-1/5"
};
var _hoisted_12 = /*#__PURE__*/_createElementVNode("label", {
  "class": "block text-gray-700 font-bold"
}, "Lead Status", -1);
var _hoisted_13 = {
  "class": "w-1/5 flex gap-2"
};
var _hoisted_14 = {
  key: 0,
  "class": "bg-white border rounded-md shadow p-4"
};
var _hoisted_15 = {
  "class": "mb-6 w-full flex justify-center"
};
var _hoisted_16 = {
  "class": "bg-white border rounded-md shadow p-4 mt-8"
};
var _hoisted_17 = ["href"];
var _hoisted_18 = /*#__PURE__*/_createTextVNode("Transfer");
var _hoisted_19 = {
  "class": "flex overflow-auto"
};
var _hoisted_20 = {
  "class": "flex justify-end"
};
var _hoisted_21 = {
  "class": "m-4"
};
var _hoisted_22 = /*#__PURE__*/_createElementVNode("h4", {
  "class": "text-center capitalize"
}, "Lead Transfer", -1);
var _hoisted_23 = {
  "class": "rounded-lg w-full mx-auto bg-white p-6",
  style: {
    "min-height": "300px"
  }
};
var _hoisted_24 = {
  "class": "py-3"
};
var _hoisted_25 = {
  "class": "bg-gray-100 w-full p-3 mb-2 flex justify-between items-center border border-fborder rounded-md"
};
var _hoisted_26 = /*#__PURE__*/_createElementVNode("span", {
  "class": "text-sm"
}, "Target", -1);
var _hoisted_27 = {
  "class": "flex items-center justify-center gap-2 w-2/3"
};
var _hoisted_28 = {
  "class": "w-full flex justify-center items-center"
};
var _hoisted_29 = /*#__PURE__*/_createElementVNode("h4", {
  "class": "text-center capitalize"
}, "Lead Transfer all", -1);
var _hoisted_30 = {
  "class": "rounded-lg w-full mx-auto bg-white p-6",
  style: {
    "min-height": "300px"
  }
};
var _hoisted_31 = {
  "class": "py-3"
};
var _hoisted_32 = {
  "class": "bg-gray-100 w-full p-3 mb-2 flex justify-between items-center border border-fborder rounded-md"
};
var _hoisted_33 = /*#__PURE__*/_createElementVNode("span", {
  "class": "text-sm"
}, "Target", -1);
var _hoisted_34 = {
  "class": "flex items-center justify-center gap-2 w-2/3"
};
var _hoisted_35 = {
  "class": "w-full flex justify-center items-center"
};
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  var _component_Head = _resolveComponent("Head");
  var _component_el_date_picker = _resolveComponent("el-date-picker");
  var _component_el_option = _resolveComponent("el-option");
  var _component_el_select = _resolveComponent("el-select");
  var _component_el_skeleton_item = _resolveComponent("el-skeleton-item");
  var _component_el_table_column = _resolveComponent("el-table-column");
  var _component_el_button = _resolveComponent("el-button");
  var _component_el_tag = _resolveComponent("el-tag");
  var _component_el_table = _resolveComponent("el-table");
  var _component_el_skeleton = _resolveComponent("el-skeleton");
  var _component_el_pagination = _resolveComponent("el-pagination");
  var _component_el_tree_select = _resolveComponent("el-tree-select");
  var _component_el_dialog = _resolveComponent("el-dialog");
  return _openBlock(), _createElementBlock(_Fragment, null, [_createElementVNode("div", _hoisted_1, [_createVNode(_component_Head, {
    title: "Research Data"
  }), _hoisted_2, _createElementVNode("div", _hoisted_3, [_createElementVNode("div", _hoisted_4, [_createElementVNode("div", _hoisted_5, [_hoisted_6, _createVNode(_component_el_date_picker, {
    modelValue: $data.startDate,
    "onUpdate:modelValue": _cache[0] || (_cache[0] = function ($event) {
      return $data.startDate = $event;
    }),
    type: "date",
    placeholder: "Start Date",
    "class": "mt-4",
    clearable: "",
    onChange: _cache[1] || (_cache[1] = function ($event) {
      return $data.showTransferAllBtn = false;
    })
  }, null, 8, ["modelValue"])]), _createElementVNode("div", _hoisted_7, [_hoisted_8, _createVNode(_component_el_date_picker, {
    modelValue: $data.endDate,
    "onUpdate:modelValue": _cache[2] || (_cache[2] = function ($event) {
      return $data.endDate = $event;
    }),
    type: "date",
    placeholder: "End Date",
    "class": "mt-4",
    clearable: "",
    onChange: _cache[3] || (_cache[3] = function ($event) {
      return $data.showTransferAllBtn = false;
    })
  }, null, 8, ["modelValue"])]), _createElementVNode("div", _hoisted_9, [_hoisted_10, _createVNode(_component_el_select, {
    modelValue: $data.selectedTenant,
    "onUpdate:modelValue": _cache[4] || (_cache[4] = function ($event) {
      return $data.selectedTenant = $event;
    }),
    placeholder: "Tenant",
    "class": "mt-4",
    filterable: "",
    clearable: "",
    onChange: _cache[5] || (_cache[5] = function ($event) {
      return $data.showTransferAllBtn = false;
    })
  }, {
    "default": _withCtx(function () {
      return [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList($props.tenantList, function (t) {
        return _openBlock(), _createBlock(_component_el_option, {
          value: t.value,
          label: t.value
        }, null, 8, ["value", "label"]);
      }), 256))];
    }),
    _: 1
  }, 8, ["modelValue"])]), _createElementVNode("div", _hoisted_11, [_hoisted_12, _createVNode(_component_el_select, {
    modelValue: $data.leadStatus,
    "onUpdate:modelValue": _cache[6] || (_cache[6] = function ($event) {
      return $data.leadStatus = $event;
    }),
    placeholder: "Lead Status",
    "class": "mt-4",
    multiple: "",
    onChange: _cache[7] || (_cache[7] = function ($event) {
      return $data.showTransferAllBtn = false;
    })
  }, {
    "default": _withCtx(function () {
      return [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList($props.leadStatuses, function (l, lname) {
        return _openBlock(), _createBlock(_component_el_option, {
          value: l,
          label: lname
        }, null, 8, ["value", "label"]);
      }), 256))];
    }),
    _: 1
  }, 8, ["modelValue"])]), _createElementVNode("div", _hoisted_13, [_createElementVNode("button", {
    "class": "text-white focus:text-indigo-500 text-sm bg-indigo-800 p-3 rounded-md mt-5",
    type: "button",
    onClick: _cache[8] || (_cache[8] = function ($event) {
      return $options.showLeads(true);
    })
  }, "Show Leads"), _createElementVNode("button", {
    "class": "text-white focus:text-indigo-500 text-sm bg-indigo-800 p-3 rounded-md mt-5",
    type: "button",
    onClick: _cache[9] || (_cache[9] = function ($event) {
      return $options.downloadLeads();
    })
  }, "Download")])])]), $data.showTransferAllBtn ? (_openBlock(), _createElementBlock("div", _hoisted_14, [_createElementVNode("div", _hoisted_15, [_createElementVNode("button", {
    "class": "text-white focus:text-indigo-500 text-sm bg-indigo-800 p-3 rounded-md mt-5 w-1/2",
    type: "button",
    onClick: _cache[10] || (_cache[10] = function ($event) {
      return $options.showTransferAllPopup();
    })
  }, "Transfer all (" + _toDisplayString($data.leadCount) + ")", 1)])])) : _createCommentVNode("", true), _createElementVNode("div", _hoisted_16, [_createVNode(_component_el_skeleton, {
    loading: $data.isLoadingRules,
    animated: "",
    count: 9
  }, {
    template: _withCtx(function () {
      return [_createElementVNode("div", null, [_createVNode(_component_el_skeleton_item, {
        variant: "h3"
      })])];
    }),
    "default": _withCtx(function () {
      return [_createVNode(_component_el_table, {
        data: $data.leadList,
        style: {
          "width": "100%"
        }
      }, {
        "default": _withCtx(function () {
          return [_createVNode(_component_el_table_column, {
            label: "Tenant",
            prop: "tenant_id"
          }), _createVNode(_component_el_table_column, {
            label: "Name"
          }, {
            "default": _withCtx(function (scope) {
              return [_createElementVNode("a", {
                "class": "text-center cursor-pointer",
                href: scope.row.contact_info.linkedin,
                target: "_blank",
                style: {
                  "color": "blue",
                  "text-decoration": "underline"
                }
              }, _toDisplayString(scope.row.contact_info.first_name) + " " + _toDisplayString(scope.row.contact_info.last_name), 9, _hoisted_17), _createElementVNode("p", null, _toDisplayString(scope.row.contact_info.title), 1), _createElementVNode("p", null, _toDisplayString(scope.row.contact_info.department), 1)];
            }),
            _: 1
          }), _createVNode(_component_el_table_column, {
            label: "Company"
          }, {
            "default": _withCtx(function (scope) {
              return [_createElementVNode("p", null, _toDisplayString(scope.row.contact_info.company_name), 1), _createElementVNode("p", null, _toDisplayString(scope.row.contact_info.industry), 1), _createElementVNode("p", null, _toDisplayString(scope.row.contact_info.country), 1), _createElementVNode("p", null, _toDisplayString(scope.row.contact_info.revenue) + " Million", 1)];
            }),
            _: 1
          }), _createVNode(_component_el_table_column, {
            label: "Lead Status",
            prop: "lead_status"
          }), _createVNode(_component_el_table_column, {
            label: "Updated Date",
            prop: "updated_at"
          }), _createVNode(_component_el_table_column, {
            label: "Transfer"
          }, {
            "default": _withCtx(function (scope) {
              return [_createVNode(_component_el_button, {
                size: "small",
                type: "danger",
                onClick: function onClick($event) {
                  return $options.transferLead(scope.row);
                }
              }, {
                "default": _withCtx(function () {
                  return [_hoisted_18];
                }),
                _: 2
              }, 1032, ["onClick"])];
            }),
            _: 1
          }), _createVNode(_component_el_table_column, {
            label: "Transfer Sucess",
            width: "250"
          }, {
            "default": _withCtx(function (scope) {
              return [_createElementVNode("div", _hoisted_19, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(scope.row.target_sucess, function (item) {
                return _openBlock(), _createBlock(_component_el_tag, {
                  key: item,
                  type: "info",
                  effect: "dark",
                  "class": "my-4 mx-2"
                }, {
                  "default": _withCtx(function () {
                    return [_createTextVNode(_toDisplayString(item), 1)];
                  }),
                  _: 2
                }, 1024);
              }), 128))])];
            }),
            _: 1
          })];
        }),
        _: 1
      }, 8, ["data"])];
    }),
    _: 1
  }, 8, ["loading"]), _createElementVNode("div", _hoisted_20, [_createElementVNode("div", _hoisted_21, [_createVNode(_component_el_skeleton, {
    loading: $data.isLoadingRules,
    animated: "",
    count: 1
  }, {
    template: _withCtx(function () {
      return [_createElementVNode("div", null, [_createVNode(_component_el_skeleton_item, {
        variant: "h3"
      })])];
    }),
    "default": _withCtx(function () {
      return [_createVNode(_component_el_pagination, {
        background: "",
        layout: "prev, pager, next",
        total: $data.leadCount,
        "current-page": $data.currentPage,
        "default-page-size": 10,
        onCurrentChange: $options.pageChange
      }, null, 8, ["total", "current-page", "onCurrentChange"])];
    }),
    _: 1
  }, 8, ["loading"])])])])]), _createVNode(_component_el_dialog, {
    modelValue: $data.showTransfer,
    "onUpdate:modelValue": _cache[14] || (_cache[14] = function ($event) {
      return $data.showTransfer = $event;
    }),
    onClose: $options.cancelTransfer,
    top: "5vh",
    center: "",
    style: {
      "min-width": "60%"
    }
  }, {
    header: _withCtx(function () {
      return [_hoisted_22];
    }),
    "default": _withCtx(function () {
      return [_createElementVNode("div", _hoisted_23, [_createElementVNode("div", null, [_createElementVNode("div", _hoisted_24, [_createElementVNode("div", _hoisted_25, [_hoisted_26, _createElementVNode("div", _hoisted_27, [_createVNode(_component_el_tree_select, {
        modelValue: $data.activeLead.target_data,
        "onUpdate:modelValue": _cache[11] || (_cache[11] = function ($event) {
          return $data.activeLead.target_data = $event;
        }),
        data: $data.popupTenantList,
        multiple: "",
        "render-after-expand": false,
        style: {
          "width": "500px"
        },
        onChange: $options.updateActiveLeadTarget,
        filterable: ""
      }, null, 8, ["modelValue", "data", "onChange"])])])])])]), _createElementVNode("div", _hoisted_28, [_createElementVNode("button", {
        "class": "ml-3 text-white focus:text-indigo-500 text-sm bg-indigo-800 p-2 rounded-md",
        onClick: _cache[12] || (_cache[12] = function () {
          return $options.cancelTransfer && $options.cancelTransfer.apply($options, arguments);
        })
      }, "Discard"), _createElementVNode("button", {
        "class": "ml-3 text-white focus:text-indigo-500 text-sm bg-indigo-800 p-2 rounded-md",
        onClick: _cache[13] || (_cache[13] = function () {
          return $options.saveTransfer && $options.saveTransfer.apply($options, arguments);
        })
      }, "Transfer")])];
    }),
    _: 1
  }, 8, ["modelValue", "onClose"]), _createVNode(_component_el_dialog, {
    modelValue: $data.showTransferAll,
    "onUpdate:modelValue": _cache[18] || (_cache[18] = function ($event) {
      return $data.showTransferAll = $event;
    }),
    onClose: $options.cancelTransferAll,
    top: "5vh",
    center: "",
    style: {
      "min-width": "60%"
    }
  }, {
    header: _withCtx(function () {
      return [_hoisted_29];
    }),
    "default": _withCtx(function () {
      return [_createElementVNode("div", _hoisted_30, [_createElementVNode("div", null, [_createElementVNode("div", _hoisted_31, [_createElementVNode("div", _hoisted_32, [_hoisted_33, _createElementVNode("div", _hoisted_34, [_createVNode(_component_el_tree_select, {
        modelValue: $data.transferAllLead,
        "onUpdate:modelValue": _cache[15] || (_cache[15] = function ($event) {
          return $data.transferAllLead = $event;
        }),
        data: $props.tenantList,
        "render-after-expand": false,
        style: {
          "width": "500px"
        },
        filterable: ""
      }, null, 8, ["modelValue", "data"])])])])])]), _createElementVNode("div", _hoisted_35, [_createElementVNode("button", {
        "class": "ml-3 text-white focus:text-indigo-500 text-sm bg-indigo-800 p-2 rounded-md",
        onClick: _cache[16] || (_cache[16] = function () {
          return $options.cancelTransferAll && $options.cancelTransferAll.apply($options, arguments);
        })
      }, "Discard"), _createElementVNode("button", {
        "class": "ml-3 text-white focus:text-indigo-500 text-sm bg-indigo-800 p-2 rounded-md",
        onClick: _cache[17] || (_cache[17] = function () {
          return $options.saveTransferAll && $options.saveTransferAll.apply($options, arguments);
        })
      }, "Transfer")])];
    }),
    _: 1
  }, 8, ["modelValue", "onClose"])], 64);
}